import styled, { css } from 'styled-components';
import { defaultMuiTheme } from '../../../../styles/MaterialTheme';
const CONTROL_BAR_HEIGHT = 4;
const MOBILE_PROGRESS_BAR_HEIGHT = 20;
const baseVideoStyles = css `
    .video-js {
        font-size: 14px;
        background-color: transparent;
        color: ${(props) => props.theme.colors.videoBorder};
        width: 100%;
        height: auto;
    }

    .vjs-poster {
        background-color: transparent;
        background-position: 50% 0;
    }

    .video-js.vjs-ended .vjs-poster {
        display: block;
    }

    video {
        margin-top: 0 !important;
    }

    .video-js.vjs-custom-skin {
        color: ${(props) => props.theme.colors.textSecondary};

        .vjs-tech {
            position: relative;
            width: 100%;
            height: auto;
            max-height: 70vh;
            border-top-right-radius: 4px;
            border-top-left-radius: 4px;
        }

        &.vjs-fullscreen {
            .vjs-tech {
                border-radius: 0;
                border: 0;
                max-height: 100%;
            }
        }

        .vjs-big-play-button {
            font-size: 45px;
            line-height: 80px;
            height: 80px;
            width: 80px;
            color: ${(props) => props.theme.colors.secondary};
            background-color: ${(props) => props.theme.colors.surface};
            border-radius: 80px;
            transition: all 0.4s;
            transition-property: all;
            transition-duration: 0.4s;
            transition-timing-function: ease;
            transition-delay: 0s;
            left: calc(50% - 40px);
            top: calc(50% - 80px);
            opacity: 0.7;
        }

        .vjs-progress-holder {
            background: ${(props) => props.theme.colors.border};
            border-left: 1px solid ${(props) => props.theme.colors.border};
            border-right: 1px solid ${(props) => props.theme.colors.border};
        }

        .vjs-play-progress {
            background: ${(props) => props.theme.colors.primaryLighter};
        }

        .vjs-load-progress {
            background: ${(props) => props.theme.colors.border};
        }

        .vjs-control-bar {
            background: ${(props) => props.theme.colors.surface};
            height: ${CONTROL_BAR_HEIGHT}em;
            padding: 0 0.5em;
        }

        .vjs-text-track-display {
            bottom: 5em !important;
        }

        &.vjs-inline {
            .vjs-control-bar {
                position: relative;
                display: flex;
                opacity: 1;
                visibility: visible;
                border: 1px solid ${(props) => props.theme.colors.border};
                border-bottom-left-radius: 4px;
                border-bottom-right-radius: 4px;
            }
        }

        &.vjs-fullscreen {
            .vjs-control-bar {
                border: 1px solid ${(props) => props.theme.colors.border};
            }
        }

        .vjs-time-control {
            line-height: ${CONTROL_BAR_HEIGHT}em;
        }

        .vjs-button > .vjs-icon-placeholder:before {
            font-size: 1.7em;
            line-height: 2.3em;
        }

        .vjs-load-progress div {
            /* For IE8 we'll lighten the color */
            background: ${(props) => props.theme.colors.border};
        }

        .vjs-volume-control {
            height: 3.8em;
            background-color: ${(props) => props.theme.colors.surface};
        }

        .vjs-volume-level {
            background-color: ${(props) => props.theme.colors.primary};
        }

        .vjs-volume-bar {
            margin: 1.8em 0.45em;

            .vjs-slider-horizontal {
                width: 8em;
                z-index: 2;
            }
        }

        .vjs-volume-panel.vjs-hover .vjs-volume-control.vjs-volume-horizontal,
        .vjs-volume-panel:active .vjs-volume-control.vjs-volume-horizontal,
        .vjs-volume-panel:focus .vjs-volume-control.vjs-volume-horizontal,
        .vjs-volume-panel .vjs-volume-control:active.vjs-volume-horizontal,
        .vjs-volume-panel.vjs-hover .vjs-mute-control ~ .vjs-volume-control.vjs-volume-horizontal,
        .vjs-volume-panel .vjs-volume-control.vjs-slider-active.vjs-volume-horizontal {
            width: 8em;
            background: ${(props) => props.theme.colors.surface};
        }

        .vjs-custom-control-spacer {
            display: flex;
            flex: 1 1 auto;
        }

        .vjs-time-divider {
            display: inherit;
            padding: 0 0.5em;
            min-width: initial;
        }

        .vjs-time-control {
            width: auto;
        }

        .vjs-current-time {
            margin-left: 1em;
        }

        .vjs-current-time,
        .vjs-duration {
            display: inherit;
            padding: 0;
        }

        .vjs-remaining-time {
            display: none;
        }

        .vjs-play-progress:before {
            display: none;
        }

        .vjs-progress-control {
            position: absolute;
            left: -1px;
            width: calc(100% + 2px);
            height: 5px;
            top: -5px;

            .vjs-progress-holder {
                margin: 0;
            }
        }

        .vjs-progress-control:hover {
            height: 1.5em;
            top: -1.5em;
        }

        .vjs-load-progress {
            width: 100%;
        }

        .vjs-progress-holder {
            margin: 0;
            height: 100%;
            width: 100%;
        }

        .vjs-seek-button.skip-back.skip-10 .vjs-icon-placeholder::before {
            font-family: 'Material Icons';
            content: 'replay_10';
        }

        .vjs-seek-button.skip-forward.skip-10 .vjs-icon-placeholder::before {
            font-family: 'Material Icons';
            content: 'forward_10';
        }

        .vjs-settings-button .vjs-icon-placeholder::before {
            font-family: 'Material Icons';
            content: 'settings';
        }

        .vjs-cast-to-tv-button .vjs-icon-placeholder::before {
            font-family: 'Material Icons';
            content: 'cast';
        }

        .vjs-menu {
            position: absolute;
            display: none;
            width: 400px;
            bottom: 38px;
            left: -213px;
            border-width: 1;
            border-top-left-radius: 4px;
            border-collapse: separate;
            cursor: default;
            color: ${(props) => props.theme.colors.textSecondary};
            background: ${(props) => props.theme.colors.surface};
            margin: 0;
        }

        .vjs-lock-showing {
            display: flex !important;
            align-items: center;
            justify-content: center;
        }

        .vjs-menu-button {
            margin: 0;
            padding: 0;
            position: relative;
        }

        .vjs-menu-button.vjs-hover .vjs-menu {
            display: none;
            background-color: ${(props) => props.theme.colors.surface};
        }

        .vjs-menu-content {
            display: flex;
            overflow: hidden;
            flex-direction: column;
            background-attachment: fixed;
            background-color: ${(props) => props.theme.colors.surface};
            padding: 1rem 2rem;
            border-top-left-radius: 4px;
            margin-left: 6.44em;
        }

        .vjs-menu-item {
            display: flex;
            text-align: left;
            margin-top: 0;
            height: 3rem;
            font-size: 0.9rem;
            background: ${(props) => props.theme.colors.surface};
            border-bottom: 1px solid ${(props) => props.theme.colors.border};
            padding: 5px;
            align-items: center;

            &:hover {
                cursor: default;
            }

            &:last-child {
                border-bottom: none;
            }
        }

        .vjs-menu-item-text {
            text-transform: capitalize;
        }

        .vjs-closed-caption-button {
            margin-left: auto;
        }

        .selector-container {
            display: flex;
            align-items: center;
        }

        .vjs-settings-menu-header {
            display: none;
        }

        .vjs-speed-selector-buttons {
            display: flex;
            margin-left: auto;
            width: auto;

            .selector-button {
                font-size: 0.8rem;
                margin-left: 0.3rem;
                padding-left: 5px;
                padding-right: 5px;
                cursor: pointer;
            }

            .selected {
                border-bottom: 2px solid ${(props) => props.theme.colors.videoBorderActive};
            }
        }

        .vjs-quality-selector-buttons {
            display: flex;
            margin-left: auto;
            width: auto;

            .selector-button {
                font-size: 0.8rem;
                margin-left: 0.3rem;
                padding-left: 5px;
                padding-right: 5px;
                cursor: pointer;
            }

            .selected {
                border-bottom: 2px solid ${(props) => props.theme.colors.videoBorderActive};
            }
        }
    }
`;
const mobileVideoStyles = css `
        padding-bottom: ${MOBILE_PROGRESS_BAR_HEIGHT}px;
        user-select: none;

        .video-js {
            font-size: 12px;
            background-color: transparent;
            color: ${(props) => props.theme.colors.videoBorder};
            height: auto;
        }


        .vjs-custom-modal-dialog {
            background: transparent;
            border: 5px solid teal;
        }

        .vjs-icon-placeholder:before {
            color: #fff;
        }

        .vjs-current-time {
            position: absolute;
            height: 50px;
            right: calc(50% + 5px);
            bottom: ${MOBILE_PROGRESS_BAR_HEIGHT}px;
        }
        .vjs-time-divider {
            position: absolute;
            height: 50px;
            left: 0;
            right: 0;
            margin-left: auto;
            margin-right: auto;
            width: 10px !important;
            bottom: ${MOBILE_PROGRESS_BAR_HEIGHT}px;
        }
        .vjs-duration {
            position: absolute;
            height: 50px;
            left: calc(50% + 10px);
            bottom: ${MOBILE_PROGRESS_BAR_HEIGHT}px;
        }
        .vjs-time-control {
            color: #fff;
        }

        .vjs-seek-button.skip-back.skip-10 {
            position: absolute;
            height: 30px;
            top: calc(50% - 15px - ${MOBILE_PROGRESS_BAR_HEIGHT / 2}px);
            right: calc(50% + 40px);
        }
        .vjs-seek-button.skip-forward.skip-10 {
            position: absolute;
            height: 30px;
            top: calc(50% - 15px - ${MOBILE_PROGRESS_BAR_HEIGHT / 2}px);
            left: calc(50% + 40px);
        }
        .vjs-seek-button.skip-back.skip-10 .vjs-icon-placeholder::before {
            font-size: 2rem;
            line-height: 2rem;
        }

        .vjs-seek-button.skip-forward.skip-10 .vjs-icon-placeholder::before {
            font-size: 2rem;
            line-height: 2rem;
        }

        .vjs-menu-button {
            height: 50px;
        }

        .vjs-cast-to-tv-button {
            height: 50px;
        }

        .vjs-picture-in-picture-control {
            display: none;
        }

        .vjs-fullscreen-control {
            position: absolute;
            height: 50px;
            right: 0;
            bottom: ${MOBILE_PROGRESS_BAR_HEIGHT}px;
        }

        .video-js.vjs-custom-skin.vjs-inline.vjs-mobile-hide-big-play-button {
            .vjs-big-play-button {
                display: none;
            }
        }

        .video-js.vjs-custom-skin.vjs-inline {
            height: auto;
            border-radius: 0;

            .vjs-tech {
                border-top-right-radius: unset;
                border-top-left-radius: unset;
            }


            .vjs-control-bar {
                /* control bar will be displayed when video player detected a 'tap' */
                display: none;
                position: absolute;
                border: 0;
                top: 0;
                left: 0;
                height: 100%;
                background: rgba(0, 0, 15, 0.4);

                /* detected through 'tap' event */
                &.vjs-mobile-active {
                    display: flex;

                    &.vjs-mobile-fade-out {
                        transition: all 250ms;
                        opacity: 0;
                    }
                }
            }

            .vjs-closed-caption-button {
                margin-right: -10px;
            }

            .vjs-big-play-button {
                top: calc(50% - 40px);
                font-size: 4rem;
                border: 0;
                background-color: transparent;
                opacity: 0.9;

                .vjs-icon-placeholder::before {
                    font-family: 'Material Icons';
                    content: 'play_circle';
                    color: ${(props) => props.theme.colors.surface};
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
            }

            .vjs-play-control {
                position: absolute;
                height: 80px;
                width: 80px;
                left: calc(50% - 40px);
                top: calc(50% - 40px - ${MOBILE_PROGRESS_BAR_HEIGHT / 2}px);
                color: ${(props) => props.theme.colors.white};
                outline: 0;

                .vjs-icon-placeholder:before {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 4.5rem;
                    line-height: 4.5rem;
                }
            }

            .vjs-volume-panel {
                display: none;
            }

            .vjs-menu {
                position: fixed;
                /* z-index higher than Feedback Button */
                z-index: 1202;
                background-color: ${(props) => props.theme.colors.surface};
                display: none;
                width: 100vw;
                bottom: 0;
                left: 0;
                margin: 0;
            }

            .vjs-menu-item {
                height: unset;
                padding: 15px 5px;
            }

            .vjs-menu-content {
                position: fixed;
                margin-left: 0;
                padding: 0.5rem;
                bottom: 0;
                left: 0;
                right: 0;
                width: 100vw;
                box-shadow: 0 0 30px ${(props) => props.theme.colors.dropShadow};
                /* leave space for mobile browser bottom nav bar */
                padding-bottom: 60px;
                border-top-left-radius: unset;
                max-height: unset;
            }

            .vjs-settings-menu-header {
                display: flex;
                justify-content: space-between;
                padding: 15px 5px;
                font-size: ${(props) => props.theme.fonts.textSizeStandard};
                font-weight: 600;

                button {
                    padding: 0;
                    width: 1rem;
                    height: 1rem;

                    &::before {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        font-family: 'Material Icons';
                        content: 'close';
                        font-size: ${(props) => props.theme.fonts.textSizeH3};
                    }
                }
            }

            .vjs-progress-holder {
                border: 0;
            }

            .vjs-progress-control {
                position: absolute;
                top: unset;
                width: 100%;
                height: ${MOBILE_PROGRESS_BAR_HEIGHT}px;
                left: 0;
                bottom: 0;
            }

            .vjs-speed-selector-buttons {
                button {
                    padding: 0.2rem 0.3rem;
                }
            }
        }
    }
`;
export const VideoContainer = styled.div `
    ${baseVideoStyles}
    ${defaultMuiTheme.breakpoints.down('xs')} {
        ${mobileVideoStyles}
    }
`;
export const MobileVideoContainer = styled.div `
    ${baseVideoStyles}
    ${mobileVideoStyles}
        .video-js.vjs-custom-skin.vjs-fullscreen {
        .vjs-play-control {
            position: absolute;
            height: 80px;
            width: 80px;
            left: calc(50% - 40px);
            top: calc(50% - 40px - ${MOBILE_PROGRESS_BAR_HEIGHT / 2}px);
            color: ${(props) => props.theme.colors.white};
            outline: 0;

            .vjs-icon-placeholder:before {
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 4.5rem;
                line-height: 4.5rem;
            }
        }
        .vjs-control-bar {
            /* control bar will be displayed when video player detected a 'tap' */
            display: none;

            position: absolute;
            border: 0;
            top: 0;
            left: 0;
            height: 100%;
            background: rgba(0, 0, 15, 0.4);

            /* detected through 'tap' event */
            &.vjs-mobile-active {
                display: flex;

                &.vjs-mobile-fade-out {
                    transition: all 250ms;
                    opacity: 0;
                }
            }
        }
    }
`;
//# sourceMappingURL=VideoViewer.style.js.map